import {ActionDispatch} from "../";
import { types } from "./types";
import * as api from "../../api/endpoints/user";
import {config} from "../../config";

import * as Cookie from "js-cookie";

export const actionCreators = {
  loginAttempt: () => ({
    type: types.LOGIN_ATTEMPT,
  }),
  loginSuccess: (user: api.User) => ({
    type: types.LOGIN_SUCCESS,
    payload: {user}
  }),
  loginFailure: (error: Error) => ({
    type: types.LOGIN_FAILURE,
    payload: {error}
  }),
  logoutSuccess: () => ({
    type: types.LOGOUT_SUCCESS,
  })
};

export function loginFromCookie(): ActionDispatch {
  return async dispatch => {
    const user = Cookie.get("user");
    dispatch(actionCreators.loginSuccess(JSON.parse(user)));
  };
}

export function loginUser(username: string, password: string): ActionDispatch {
  return async dispatch => {
    dispatch(actionCreators.loginAttempt());

    try {
      const user = await api.login(username, password);
      Cookie.set("user", JSON.stringify(user), {expires: config.cookieExpiration});
      dispatch(actionCreators.loginSuccess(user));
    }
    catch (error) {
      dispatch(actionCreators.loginFailure(error));
    }
  };
}

export function logoutUser(): ActionDispatch {
  return async dispatch => {
    Cookie.remove("user");
    dispatch(actionCreators.logoutSuccess());
  };
}



// WEBPACK FOOTER //
// ./src/reducers/user/actions.ts